import AlertsController from './AlertsController';

export default AlertsController;